function getFirstPartyData(contractDetails) {
  const { visa_provider } = contractDetails;
  return [
    {
      title: "Operations Department",
      name:
        visa_provider?.authorized_project_representative_name ||
        "<Authorized Project Representative>",
      designation:
        visa_provider?.authorized_project_representative_designation ||
        "<Authorized Project Representative Designation>",
      signature: " ",
    },
    {
      title: "Finance Department",
      name:
        visa_provider?.authorized_accounts_representative_name ||
        "<Authorized Accounts Representative Name>",
      designation:
        visa_provider?.authorized_accounts_representative_designation ||
        "<Authorized Accounts Representative Designation>",
      signature: " ",
    },
    {
      title: "Approved By",
      name:
        visa_provider?.authorized_person_name ||
        "<Signing Authority Person Name>",
      designation:
        visa_provider?.authorized_person_designation ||
        "<Signing Authority Person Designation>",
      signature: " ",
    },
  ];
}

function getSecondPartyData(contractDetails) {
  const { client } = contractDetails;

  return [
    {
      title: "Operations / HR Department",
      name:
        client?.authorized_project_representative_name ||
        "<Authorized Person Name",
      designation:
        client?.authorized_project_representative_designation ||
        "<Authorized Person Designation",
      signature: " ",
    },
    {
      title: "Finance / HR Department",
      name:
        client?.authorized_accounts_representative_name ||
        "<Authorized Accounts Representative Name",
      designation:
        client?.authorized_accounts_representative_designation ||
        "<Authorized Accounts Representative Designation",
      signature: " ",
    },
    {
      title: "Approved By",
      name: client?.authorized_person_name || "<Authorized Person Name>",
      designation:
        client?.authorized_person_designation ||
        "<Authorized Person Designation>",
      signature: " ",
    },
  ];
}

function getMonthlyChargesTableRows(contractDetails) {
  let tableArrays = [];
  let tableRowData = {};
  const { job_possition, visa_profession, nationality, profession_level } =
    contractDetails;

  let basicInfo =
    contractDetails?.contract_cost_sheet_profession_basic_information;
  let costSheetDetails = contractDetails?.contract_cost_sheet_cost_details;
  let costSheetHeading = contractDetails?.contract_cost_sheet_headings;
  basicInfo?.forEach((item) => {
    tableRowData.gender = item?.gender;
    tableRowData.actual_profession = job_possition?.find(
      (ele) => ele.id == item?.job_position_id
    )?.name;
    tableRowData.visa_profession = visa_profession?.find(
      (ele) => ele.id == item?.visa_profession_id
    )?.name;
    tableRowData.profession_level = profession_level?.find(
      (ele) => ele.id == item?.profession_level_id
    )?.name;
    tableRowData.nationality = nationality?.find(
      (ele) => ele.id == item?.nationality_id
    )?.name;
    tableRowData.quantity = item?.quantity;
    let costSheetTotalCost = 0;
    let totalEmployeeCost = 0;
    let totalGovernmentCost = 0;
    let totalSoundlineCost = 0;
    costSheetDetails?.forEach((cost) => {
      if (
        cost?.contract_cost_sheet_profession_basic_information_id == item.id
      ) {
        costSheetHeading?.forEach((heading, headIndex) => {
          if (cost?.contract_cost_sheet_heading_id == heading?.id) {
            if (heading?.rate_category_id == 1) {
              totalEmployeeCost += Number(cost?.cost);
            }
            if (heading?.rate_category_id == 2) {
              totalGovernmentCost += Number(cost?.cost);
            }
            if (heading?.rate_category_id == 3) {
              totalSoundlineCost += Number(cost?.cost);
            }
            costSheetTotalCost =
              Number(costSheetTotalCost) + Number(cost?.cost);
            // basic
            if (heading?.type == "Default") {
              tableRowData[
                String(heading?.rate_category_item?.name)
                  .trim()
                  .split(" ")
                  .join("_")
                  .toLowerCase()
              ] = cost?.cost;
            } else if (heading?.type == "Dynamic") {
              tableRowData[
                String(heading?.rate_category_item_name)
                  .trim()
                  .split(" ")
                  .join("_")
                  .toLowerCase()
              ] = cost?.cost;
            }
          }
        });
      }
    });

      tableRowData.total_employee_salary_package =
        Number(totalEmployeeCost).toFixed(2);
      tableRowData.total_government_fees =
        Number(totalGovernmentCost).toFixed(2);
      tableRowData.total_soundline_fees = Number(totalSoundlineCost).toFixed(2);
    tableRowData.total_monthly_cost_head =
      Number(costSheetTotalCost).toFixed(2);
    tableRowData.per_day_hour = Number(
      Number(costSheetTotalCost) /
        26 /
        Number(contractDetails?.contract?.hour_type)
    ).toFixed(2);
    tableArrays.push(tableRowData);
    tableRowData = {};
  });

  return tableArrays;
}

const MONTHLY_CHARGES_COLUMNS = [
  {
    col: "Actual Profession",
    title: "actual_profession",
  },
  {
    col: "Visa Profession",
    title: "visa_profession",
  },
  {
    col: "Profession Level",
    title: "profession_level",
  },
  {
    col: "Gender",
    title: "gender",
  },
  {
    col: "Nationality",
    title: "nationality",
  },
  {
    col: "Quantity",
    title: "quantity",
  },
  {
    col: "Basic",
    title: "basic",
  },
  {
    col: "Food",
    title: "food",
  },
  {
    col: "Fixed OT",
    title: "fixed_ot",
  },
  {
    col: "HRA",
    title: "hra",
  },
  {
    col: "Travel Allowance",
    title: "travel_allowance",
  },
  {
    col: "Total Monthly Per Head Cost",
    title: "total_monthly_cost_head",
  },
  {
    col: "Per Day Hours",
    title: "per_day_hour",
  },
];

const currentDate = new Date();
const year = currentDate.getFullYear();
const TABLE_TWO_DATA = [
  {
    text: `* Valid  only for ${year} (in future, rates shall be changed with respect to changes in KSA Govt. charges, if any).  The charges provided above are subject to change as per further amendments in current laws or new laws introduced by KSA government, changes in Nitaqat percentage slabs, changes in taxes that affect our cost (for example work permit, VAT, Saudi salary etc.) shall be applied & charged to Second PARTY at actuals.`,
  },
  {
    text: `**GoSI will be charged monthly in addition (GoSI is 2% on Basic+HRA, if there is no HRA, it considers 17% of Basic as HRA).`,
  },
  {
    text: `**Any incentive/OT will be charged & paid as advised by Second Party.`,
  },
];

const TABLE_TWO_ARABIC_DATA = [
  {
    text: `* صالحة فقط ${year} (في المستقبل ، سيتم تغيير الأسعار وفقًا للتغييرات في رسوم الحكومة السعودية ، إن وجدت). تخضع الرسوم المذكورة أعلاه للتغيير وفقًا للتعديلات الإضافية في القوانين الحالية أو القوانين الجديدة التي أدخلتها حكومة المملكة العربية السعودية ، والتغييرات في ألواح نطاق النسبة المئوية ، والتغييرات في الضرائب التي تؤثر على التكلفة (مثل تصريح العمل ، وضريبة القيمة المضافة ، والراتب السعودي ، وما إلى ذلك). يتم تطبيقها وتحميلها على الطرف الثاني بالقيم الفعلية.`,
  },
  {
    text: `** بالإضافة إلى ذلك سيتم فرض رسوم  شهرية لمؤسسة التامينات الإجتماعية  (هي 2٪ على الأساسي + بدل الإيجار، إذا لم يكن هناك ، فإنها تحتسب 17٪ من الأساسي).`,
  },
  {
    text: `** سيتم فرض ودفع أي حافز / الوقت الإضافي وفقًا لما ينصح به الطرف الثاني.`,
  },
];

function getTermsTableEnglishData(contractDetails) {
  return [
    {
      text: `Contracts Period Between: ${
        contractDetails?.contract?.start_date || "<CONTRACT START DATE>"
      } and ${contractDetails?.contract?.end_date || "<CONTRACT END DATE>"}`,
      sub: [],
    },
    {
      text: `Contract Renewal: Upon completion of contract, the contract automatically renews for same period of time 
    (i.e. ${contractDetails?.contract?.tenure || "<CONTRACT TENURE>"} months).`,
      sub: [],
    },
    {
      text: `Notice period to terminate the Contract: To terminate the contract, either party need to issue a notice to the other party, 60 days prior to Contract Expiry date.`,
      sub: [],
    },
    {
      text: `Refundable Security Deposit Payment: FIRST PARTY shall invoice SECOND PARTY, Two months full-monthly charge against Security Deposit.  This will be as Security Deposit, to use in worst case scenarios to pay-off the employee benefits/to cover damages.  This Refundable Deposit Payment will be returned on completion of the Contract OR adjusted against the last 2 Invoices.  The First security deposit invoice will be based on initial requirement quantities, for any additional requirements, separate invoices will be raised accordingly.`,
      sub: [],
    },
    {
      text: `Initial Invoice:`,
      sub: [
        "Security Deposit – Two (2) month full-monthly charge (Salary and service fee).",
        "Invoice payment should be made within 10 days after sign & submission of the contract.",
      ],
    },
    {
      text: `Employee Selection: Local-inside KSA / Overseas – sourcing can be assist by First Party & selection by SECOND PARTY.`,
      sub: [],
    },
    {
      text: `Replacement of Personnel: The Employee will initially be on a probationary period of three (03) months.  Should the Second Party decide to terminate an employee within the probation period, because the employee’s performance is not considered satisfactory or he is physically unfit or not willing to work, the First Party upon notification of the Second Party shall replace the employee accordingly. If the Employee completes his probation period and the Second Party Terminates the employee for a valid reason, the Second Party shall pay the Iqama, work permit and Government costs to the First Party on pro-rata. The Second Party shall provide minimum two warning letters with intimation to the First Party and only then terminate the employee. This clause is only for candidates selected under the Guarantee of the First Party.`,
      sub: [],
    },
    {
      text: `If any candidate is selected/ referred by Second Party or recruited through a third-party agency, the recruitment cost will remain same as that of Sourced candidates. The processing fees should be paid by the candidate. If the candidate is not ready to pay, the same shall be borne by Second Party. First Party   will not be responsible for any replacement against referred or third party sourced candidates. If candidate refuses to work, Resigns, is terminated or absconds or goes back to their home country, Second Party will be liable to pay the balance government cost on prorata + 2 Months Admin & Service charges of the First Party towards the respective employee.  `,
      sub: [],
    },
    {
      text: `Accommodation: shall provide by SECOND PARTY.`,
      sub: [],
    },
    {
      text: `Transportation: shall provide by SECOND PARTY.`,
      sub: [],
    },
    {
      text: `The monthly service charges include Visa, Work Permit, Iqama fee, Medical for iqama, Health Insurance, Salary, GoSI, Nitaqat, Ajeer, ATM Card, Vacation Pay, Vacation air-ticket, Exit re-entry fee, admin charges and End of Service Benefits (EoSB).`,
      sub: [],
    },
    {
      text: `The employee salary and First Party monthly service charge will start from the date of arrival of the Employee. Any delay in opening of the Projects or outlets of the Second Party should not affect the salary of the employees and First Party   service charges.`,
      sub: [],
    },
    {
      text: `Other costs by SECOND Party:`,
      sub: [
        "Recruitment Agency (of sourcing country) Service Charges: Recruitment agency charges, visa stamping charges shall borne by SECOND PARTY & pay directly to the Agency.",
        "Quarantine (Hotel, Taxi, medical) & other miscellaneous charges – First Party can assist in organizing the services & the charges shall be borne by Second Party.",
        "Joining Air Ticket: shall borne by Second party or by the Employee.",
        "Airport Pick-up / Drop: shall arrange by SECOND PARTY.",
        "Violations & Processing charges: if any violations exists, actual costs will be invoiced and shall borne by SECOND Party (one-time).",
        "Baladiya: shall arrange by SECOND PARTY at its cost.",
        "Final Exit visa: FIRST PARTY shall provide up on SECOND PARTY approval only.  If any employee is found threat to the First Party reputation, First Party can issue Final Exit directly and shall inform SECOND Party on the scenario.",
      ],
    },
    {
      text: `Monthly salary invoicing & payment time-line:`,
      sub: [
        "Timesheet submission (by Second Party): 21st to 22nd of the month.",
        "Invoice Submission (by First Party): 22nd of the month.",
        "Invoice Payment (by Second Party): 23rd to 25th of the month.",
        "Salary Payment (by First Party): 1st to 5th of the next month.",
      ],
    },
    {
      text: `Pre-mature Termination Penalties: if SECOND Party terminates FIRST Party or its’ any employee services during the contract, SECOND Party shall bear the below costs:`,
      sub: [
        "50% of FIRST Party Service Fee for the remaining contract period.",
        "Return air ticket for the Employee.",
        "This applies even if the candidate went on Exit Re-Entry (approved by Second Party) and did not return.  And it is exempted for Employee Abscond/Run-away cases.",
      ],
    },
    {
      text: `SECOND PARTY can terminate the contract with FIRST PARTY, if FIRST PARTY`,
      sub: [
        "Stops/abandons SECOND PARTY operations without any intimation.",
        "Violate the conditions of the Agreement.",
        "Goes Bankrupt.",
        "However, SECOND PARTY has to provide a written notice to FIRST PARTY to rectify the issue providing with sufficient time line to do so (minimum 1 week to a month based on the case).",
      ],
    },
    {
      text: `FIRST Party can terminate the contract with SECOND Party, if SECOND Party delay in payments.  However, FIRST Party has to provide a written notice to SECOND Party to act on the same (minimum one week to 15 days).  In addition, the pre-mature termination charges will be applied & invoiced to SECOND Party.`,
      sub: [],
    },
    {
      text: `The employee salary and First Party monthly service charge will start from the date of arrival of the Employee. Any delay in opening of the Projects or outlets of the Second Party should not affect the salary of the employees and First Party   service charges.`,
      sub: [],
    },
    {
      text: `If any candidate is absent for one day, only one day deduction should be done from his Basic salary. Also this should not affect any Government cost of First party charges.
    `,
      sub: [],
    },
    {
      text: `The First Party charges will start from the date of Kiwa Request sent for Local Transfer and for Overseas, from date of arrival in Saudi Arabia`,
      sub: [],
    },
    {
      text: `Absenteeism: If any candidate is absent due to health issues and has informed the superior or presented the Medical bill, his salary should not be deducted. The Second party shall pay the salary of this worker for that particular day/ days. If the candidate takes an unplanned leave without informing anyone, his/ her salary should be deducted as per number of days absent and not any additional days. In any case, the First Party’s monthly cost and Government costs should not be affected. This should be paid in full.`,
      sub: [],
    },
    {
      text: `If any candidate resigns due to issues in work, accommodation, ill treatment, or any issues which are not resolved by the Second Party, the Second Party will need to pay the respective Employees Government costs (on Prorata) and two months service charges of the First Party along with return ticket of the worker`,
      sub: [],
    },
    {
      text: `Workers leaves/ annual vacation amount and ticket will be provided to the worker by the First Party only on completion of the 1 years contract. If the Second Party is approving or has committed to the worker for any leaves before contract period, the First Party shall not pay any Vacation salary, ticket amount etc. All travel costs etc, should be managed by the Employee himself or the Second Party. During the leave period of the worker, the First Party shall invoice all the government charges included First Party Monthly charges except the candidate’s salary.`,
      sub: [],
    },
    {
      text: `If the candidate doesn’t come back from his home country or any country where the Second Party has sent the worker to (trainings, meetings etc), the Second party shall be liable to pay the monthly Government costs + Admin fee and Service charges of the Employee for the entire contract period. During the leave period of the worker, the First Party shall invoice all the government charges included First Party Monthly charges except the candidate’s salary`,
      sub: [],
    },
    {
      text: `If the Employee goes on Annual Vacation and doesn’t return back due to whatsoever reason, the Second Party shall pay the Government cost incurred for the worker on pro-rata basis along with 2 months Admin & Service charge of the First Party`,
      sub: [],
    },
    {
      text: `Abscond Report: As the employees working under SECOND Party supervision, upon abscond or run-away of any employee, SECOND Party has to inform FIRST Party to declare it to Ministry through online.`,
      sub: [],
    },
    {
      text: `Liability on Damages: FIRST Party or its employees will not be responsible for SECOND Party valuables / properties.  Any kind of illegal act such as Assault, theft, loss by any employee of FIRST Party, SECOND Party can take legal action against that individual (but not on the organization).`,
      sub: [],
    },
    {
      text: `First Party shall provide any supporting documents requested by Employee or by SECOND Party.  The corresponding charges such as Chamber of Commerce attestation and Ministry of Foreign Affairs attestation will be invoiced to SECOND Party.`,
      sub: [],
    },
  ];
}
function getTermsTableArabicData(contractDetails) {
  return [
    {
      //1
      text: `مدة العقد : ${
        contractDetails?.contract?.start_date || "<تاريخ بداية العفد>"
      } و ${contractDetails?.contract?.end_date || " <تاريخ نهاية العقد>"}`,
      sub: [],
    },
    {
      //2
      text: `تجديد العقد: عند الانتهاء  يتم تجديد العقد تلقائيًا لنفس الفترة الزمنية ، (${
        contractDetails?.contract?.tenure || "<مدة العقد> "
      } شهر)`,
      sub: [],
    },
    {
      //3
      text: `فترة الإخطار لإنهاء العقد: ، يتعين على أي من الطرفين إصدار إخطار للطرف الآخر ، قبل (60) يومًا من تاريخ إنتهاء العقد`,
      sub: [],
    },
    {
      //4
      text: `دفعة تأمين قابلة للاسترداد:`,
      sub: [
        `يجب على الطرف الأول إرسال فاتورة للطرف الثاني ، رسوم شهرية كاملة مقابل وديعة الضمان. سيكون هذا بمثابة وديعة تأمين ، لاستخدامها في أسوأ السيناريوهات لسداد مزايا الموظفين / لتغطية الأضرار. سيتم إرجاع دفعة الوديعة القابلة للاسترداد هذه عند اكتمال العقد أو تعديلها مقابل آخر فاتورتين. ستعتمد فاتورة إيداع الضمان الأولى على كميات المتطلبات الأولية ، ولأي متطلبات إضافية ، سيتم رفع فواتير منفصلة وفقًا لذلك`,
      ],
    },
    {
      //5
      text: `الفاتورة الأولية :`,
      sub: [
        "وديعة التأمين - رسوم شهرين (2) كاملة - شهريًا (إجمالي الراتب ورسوم الخدمة لكل عميل)",
        `يجب أن يتم سداد الفاتورة في غضون 10 أيام بعد توقيع العقد وتقديمه.`,
      ],
    },
    {
      //6
      text: `اختيار الموظف: محلي - داخل المملكة العربية السعودية / في الخارج - إختيار من قبل الطرف الثاني.`,
      sub: [],
    },
    {
      //7
      text: `إستبدال الموظفين :سيكون الموظف في البداية في فترة إختبار مدتها (03) ثلاثة أشهر ، إذا قرر الطرف الثاني إنهاء خدمة الموظف خلال فترة الإختبار لأن اداء الموظف لا يعتبر مرضياً او انه غير لائق بدنياً او غير راغب في العمل ، يقوم الطرف الاول عند إخطار الطرف الثاني له بإستبدال الموظف وفقاً لذلك .إذا اكمل الموظف فترة الإختبار الخاصة به وقام الثاني بالإنهاء لسبب وجيه، يجب على الطرف الثاني دفع الإقامة وتصريح العمل والتكاليف الحكومية للطرف الأول على اساس نسبي ، يجب على الطرف الثاني تقديم رسالتين تحذيريتين كحد ادنى مع تنبيه للطرف الاول وبعد ذلك فقط ينهي الموظف . هذا البند مخصص فقط للمرشحين المختارين بموجب ضمان الطرف الاول .`,
      sub: [],
    },
    {
      //8
      text: `إذا تم إختيار / إحالة اي مرشح من قبل طرف ثاني او تم نجنيده من خلال وكالة تابعة لجهة خارجية ، فستظل تكلفة التوظيف مماثلة  لتلك الخاصة بالمرشحين من مصادر ، يجب أن يدفع المرشح رسوم المعالجة . إذا لم يكن المرشح جاهزاً للدفع فيجب أن يتحمل الطرف الثاني المبلغ . لن يكون الطرف الاول مسؤولاً عن إستبدال اي من المرشحين المحالين من مصادر او من مصادر خارجية ، إذا رفض المرشح العمل او إستقال او تم إنهاء عمله او هرب او عاد إلى وطنه ، فسيكون الطرف الثاني مسؤولاص عن دفع رصيد التكلفة الحكومية بالتناسب + رسوم الإدارة والخدمة لمدة شهرين  للطرف الاول تجاه الموظف المعني .`,
      sub: [],
    },
    {
      //9
      text: `السكن يتم توفيره من قبل الطرف الثاني .`,
      sub: [],
    },
    {
      //10
      text: `النقل يجب توفيره من قبل الطرف الثاني `,
      sub: [],
    },
    {
      //11
      text: `الدفعات الشهرية تشمل رسوم الخدمة الشهرية للتأشيرة ، وتصريح العمل ورسوم الإقامة ، والفحص الطبي للإقامة ، والفحص الطبي للإقامة ، التأمين ، الراتب ، التأمينات الإجتماعية ، نطاقات ، أجير ، بطاقة الصراف الآلي ، دفع الإجازات ، وتذكرة الإجازة ، رسوم الخروج والعودة ، الرسوم الإدارية ومزايا نهاية الخدمة`,
      sub: [],
    },
    {
      //12
      text: `يبدأ راتب الموظف ورسوم الخدمة الشهرية للطرف الأول من تاريخ وصول الموظف. يجب ألا يؤثر أي تأخير في افتتاح مشاريع أو منافذ الطرف الثاني على رواتب الموظفين ورسوم خدمات الطرف الأول`,
      sub: [],
    },
    {
      //13
      text: `مصروفات أخرى على الطرف الثاني :`,
      sub: [
        `رسوم خدمة وكالة التوظيف (البلد المصدر): يتحمل الطرف الثاني رسوم وكالة التوظيف ورسوم ختم التأشيرة ويتم دفعها مباشرة إلى الوكالة .`,

        `الحجر الصحي (فندق ، سيارة أجرة ،الفحص الطبي) ورسوم متنوعة أخرى - يمكن للطرف الأول المساعدة في تنظيم الخدمات ويتحمل الطرف الثاني  الرسوم .`,
        `تذاكر الطيران يتحملها الطرف الثاني او الموظف .`,

        `النقل من المطار: مسئوولية   الطرف الثاني .`,

        `رسوم الإنتهاكات والمعالجة: في حالة وجود أي إنتهاكات ، سيتم
    إصدار فاتورة بالتكاليف الفعلية ويتحملها الطرف الثاني (لمرة واحد) .`,

        `البلدية: يتم الترتيب من قبل الطرف الثاني على نفقته .`,

        `تأشيرة الخروج النهائي: يجب على الطرف الأول تقديم موافقة الطرف الثاني فقط. إذا وجد أي موظف تهديدًا لسمعة الطرف الأول ، فيمكن للطرف الأول إصدار الخروج النهائي مباشرةً وإبلاغ الطرف الثاني بالسيناريو .`,
      ],
    },
    {
      //14
      text: `فواتير الراتب الشهرية والجدول الزمني للدفع :`,
      sub: [
        `تقديم سجل الدوام (من قبل الطرف الثاني): من 21 إلى 22 من الشهر`,
        `تقديم الفاتورة (من قبل الطرف الأول): يوم 22 من الشهر .`,
        `دفع الفاتورة إلى الطرف الثاني من تاريخ 23 – 25 في الشهر .`,
        `دفع الراتب (من قبل الطرف الأول) من تاريخ (01) الأول إلى الخامس (05) من الشهر التالي.`,
      ],
    },
    {
      //15
      text: `عقوبات الإنهاء قبل إنتهاء مدة العقد :`,
      sub: [
        `إذا انهى الطرف الثاني الطرف الاول او اي من خدمات الموظفين الخاصين به أثناء العقد ، يتحمل الطرف الثاني التكاليف التالية :`,
        `50% من رسوم خدمة الطرف الأول للفترة المتبقية من العقد .`,
        `تذكرة طيران العودة للموظف.`,
        `ينطبق هذا حتى إذا ذهب المرشح خروج وعودة ( وافق عليه 
              الطرف الثاني ) ولمد يعد وتستثنى  حالات  الغياب/ الهروب`,
      ],
    },
    {
      //16
      text: `يمكن للطرف الثاني إنهاء العقد مع الطرف الأول ، إذا كان الطرف الأول :`,
      sub: [
        `توقف / تخلى عن عمليات الطرف الثاني دون تنبيه .`,
        `مخالفة شروط الاتفاقية .`,
        `اعلان الإفلاس .`,
        `ومع ذلك يتعين على الطرف الثاني تقديم إخطار كتابي إلى الطرف الاول لتصحيح المشكلة  مع توفير جدول زمني كافٍ للقيام بذلك ( الحد الأدنى من أسبوع إلى شهر بناءً على الحالة )`,
      ],
    },
    {
      //17
      text: `يمكن للطرف الأول إنهاء عقد الطرف الثاني إذا تأخر الطرف الأول في المدفوعات . ومع ذلك يتعين على الطرف الثاني تقديم إخطار  كتابي لتصحيح المشكلة مع جدول زمني كافٍ للقيام بذلك 
          ( الحد الأدنى من أسبوع إلى شهر بناءً على الحالة ) . سيتم تطبيق رسوم الإنهاء  قبل النضج وإصدار فاتورة بها إلى الطرف الثاني`,
      sub: [],
    },
    {
      text: `يبدأ راتب الموظف ورسوم الخدمة الشهرية للطرف الأول من تاريخ وصول الموظف. يجب ألا يؤثر أي تأخير في افتتاح مشاريع أو منافذ الطرف الثاني على رواتب الموظفين ورسوم خدمات الطرف الأول`,
      sub: [],
    },
    {
      text: `في حال تغيب أي مرشح ليوم واحد يتم خصم يوم واحد فقط من راتبه الأساسي. كما يجب ألا يؤثر ذلك على أي تكلفة حكومية لرسوم الطرف الأول.`,
      sub: [],
    },
    {
      text: `ستبدأ رسوم الطرف الأول من تاريخ إرسال طل (قوى) التحويل المحلي وللخارج ، من تاريخ الوصول إلى المملكة العربية السعودية.`,
      sub: [],
    },
    {
      text: `التغيب عن العمل: إذا تغيب أي مرشح لأسباب صحية وأبلغ الرئيس او قدم الفاتورة الطبية ، فلا يجوز خصم راتبه. يلتزم الطرف الثاني بدفع أجر هذا العامل عن ذلك اليوم / الأيام المحددة. إذا أخذ المرشح إجازة غير مخطط لها دون إبلاغ أي شخص ، فيجب خصم راتبه / راتبها حسب عدد الأيام المتغيبة وليس أي أيام إضافية. في أي حال ، يجب ألا تتأثر التكلفة الشهرية للطرف الأول والتكاليف الحكومية. يجب دفع هذا بالكامل.`,
      sub: [],
    },
    {
      text: `إذا استقال أي مرشح بسبب مشاكل في العمل ، أو الإقامة ، أو سوء المعاملة ، أو اي قضايا لم يتم حلها من قبل الطرف الثاني ، فسيحتاج الطرف الثاني إلى دفع التكاليف الحكومية للموظفين المعنيين (بالتناسب)  ورسوم خدمة شهرين من الطرف الأول مع تذكرة عودة العامل .`,
      sub: [],
    },
    {
      text: `إجازات العمل / سيتم تأمين قيمة الإجازة السنوية والتذكرة للعامل من قبل الطرف الأول فقط عند الانتهاء من عقد مدته سنة واحدة. إذا وافق الطرف الثاني على أي إجازات قبل فترة العقد أو التزم بها ، فلا يجوز للطرف الأول دفع أي راتب إجازة أو مبلغ التذكرة إلخ. يجب أن يدير الموظف نفسه أو الطرف الثاني جميع تكاليف السفر وما إلى ذلك. خلال فترة إجازة العامل ، يقوم الطرف الأول بفاتورة جميع الرسوم الحكومية بما في ذلك الرسوم الشهرية للطرف الأول باستثناء راتب المرشح .`,
      sub: [],
    },
    {
      text: `إذا لم يعد المرشح من وطنه أو أي بلد أرسل فيه الطرف الثاني العامل إلى (التدريبات والاجتماعات وما إلى ذلك) ، فسيكون الطرف الثاني مسؤولاً عن دفع التكاليف الحكومية الشهرية + الرسوم الإدارية ورسوم الخدمة الخاصة بـ الموظف طوال فترة العقد. خلال فترة إجازة العامل ، يقوم الطرف الأول بفاتورة جميع الرسوم الحكومية بما في ذلك الرسوم الشهرية للطرف الأول باستثناء راتب المرشح.`,
      sub: [],
    },
    {
      text: `إذا ذهب الموظف في إجازة سنوية ولم يعد مرة أخرى لإي سبب من الأسباب ، يتعين على الطرف الثاني دفع التكلفة الحكومية المتكبدة للعامل على أساس تناسبي إلى جانب رسوم الإدارة والخدمة لمدة شهرين للطرف الأول .`,
      sub: [],
    },
    {
      text: `تقرير الغياب : نظرًا لأن الموظفين  يعملون تحت إشراف الطرف الثاني ، عند فرار أو هروب أي موظف ، يتعين على الطرف الثاني  إبلاغ  الطرف لالأول لإبلاغ ذلك للوزارة عبر الإنترنت .`,
      sub: [],
    },
    {
      text: `المسؤولية عن الأضرار: لن يكون الطرف الأول أو موظفيه مسؤولين عن ممتلكات  الطرف الثاني. يمكن لأي نوع من الأعمال غير القانونية ان تحدث مثل الاعتداء والسرقة والخسارة من قبل أي موظف من الطرف الاول ، يمكن للطرف الثاني اتخاذ إجراء قانوني ضد هذا الفرد (ولكن ليس على المنظمة).`,
      sub: [],
    },
    {
      text: `يجب على الطرف الأول تقديم أي مستندات داعمة يطلبها الموظف أو الطرف الثاني. سيتم إرسال فاتورة بالرسوم المقابلة مثل شهادة غرفة التجارة وشهادة وزارة الخارجية إلى الطرف الثاني .`,
      sub: [],
    },
  ];
}

export {
  MONTHLY_CHARGES_COLUMNS,
  getMonthlyChargesTableRows,
  TABLE_TWO_DATA,
  TABLE_TWO_ARABIC_DATA,
  getTermsTableArabicData,
  getTermsTableEnglishData,
  getFirstPartyData,
  getSecondPartyData,
};
